import service from "@/utils/request";

// 中心详情
export const getStoreInfoApi = () => {
  return service({
    url: "/api/v1/org/detail",
    method: "get",
  });
};

// 中心分享信息
export const getStoreShareInfoApi = () => {
  return service({
    url: "/api/v1/org/share",
    method: "get",
  });
};

// 编辑中心信息
export interface editStoreInfoInter {
  province_id: number;
  city_id: number;
  district_id: number;
  address_info: string;
  x_point: string;
  y_point: string;
  image: string;
  video?: string;
}
export const editStoreInfoApi = (data: editStoreInfoInter) => {
  return service({
    url: "/api/v1/org/edit",
    method: "post",
    data,
  });
};

// 中心开关设置
export interface setStoreSwitchInter {
  key: string;
  status: number;
}
export const setStoreSwitchApi = (data: setStoreSwitchInter) => {
  return service({
    url: "/api/v1/org/config/switch_modify",
    method: "post",
    data,
  });
};

// 配置内容修改
export const contentModifyApi = (data: { key: string; content: number }) => {
  return service({
    url: "/api/v1/org/config/content_modify",
    method: "post",
    data,
  });
};

// 操作日志列表
export interface getOperationLogInter {
  page: number;
  page_size: number;
  code?: number[];
  relation_id?: number;
  staff_id?: number;
  detail?: string;
  create_time_start?: string;
  create_time_end?: string;
  sort_field?: string;
  sort_type?: string;
}
export const getOperationLogApi = (data: getOperationLogInter) => {
  return service({
    url: "/api/v1/operation/log/list",
    method: "post",
    data,
  });
};
// 操作类型
export const getOperationCodeApi = () => {
  return service({
    url: "/api/v1/operation/log/code",
    method: "get",
  });
};
// 添加操作日志
export const createOperationLogApi = (data: {
  code: number;
  detail: string;
}) => {
  return service({
    url: "/api/v1/operation/log/create",
    method: "post",
    data,
  });
};
